import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'main/store';
import { convertToReferanceDialogData, convertToUpdateDialogData } from '../state';

const selectScheduleDialog = (state: RootState) => state.schedule.dialog;

export const selectScheduleDialogData = (state: RootState) => selectScheduleDialog(state).data;

export const selectEventReferenceDialogData = createSelector(
    [selectScheduleDialog],
    ({ isReference, data }) => isReference && data ? convertToReferanceDialogData(data) : null
);

export const selectEventDialogData = createSelector(
    [selectScheduleDialog],
    ({ isReference, data }) => !isReference && data ? convertToUpdateDialogData(data) : null
);

export const selectEventDialogDataId = createSelector(
    [selectEventDialogData],
    (data) => data && data.id ? data.id : null
);

export const selectEventDialogDataType = createSelector(
    [selectEventDialogData],
    (data) => data ? data.type : null
);

export const selectEventDialogDataStartTimeDate = createSelector(
    [selectEventDialogData],
    (data) => data ? new Date(data.startDatetime) : null
);

export const selectEventDialogDataEndTimeDate = createSelector(
    [selectEventDialogData],
    (data) => data ? new Date(data.endDatetime) : null
);

export const selectEventFormDialogPlace = createSelector(
    [selectEventDialogData],
    (data) => data ? data.place : ''
);

export const selectEventFormDialogDescription = createSelector(
    [selectEventDialogData],
    (data) => data ? data.description : ''
);